import React from "react"
import ReactDOM from "react-dom"

import { Context } from "../utility/context"

class Visibility extends React.Component {
  static contextType = Context;
  node = null;

  state = {
    isVisible: false,
  }

  componentDidMount () {
    this.node = ReactDOM.findDOMNode(this);
    this.checkVisibility();
  }

  componentDidUpdate(prevProps) {
    this.node = ReactDOM.findDOMNode(this);
    this.checkVisibility();
  }

  checkVisibility () {
    if (!this.node) {
      return false;
    }

    const rectElement = this.normalizeRect(this.roundRectDown(this.node.getBoundingClientRect()));
    const rectWindow = {
      top: this.context.visibility.scroll,
      bottom: this.context.visibility.scroll + this.context.visibility.height,
    }

    let isVisible;

    if (rectElement.bottom > rectWindow.top && rectElement.top < rectWindow.bottom) {
      isVisible = true;
    } else {
      isVisible = false;
    }

    if (isVisible !== this.state.isVisible) {
      this.setState({
        isVisible: isVisible,
      });
    }
  }

  roundRectDown(rect) {
    return {
      top: Math.floor(rect.top),
      left: Math.floor(rect.left),
      bottom: Math.floor(rect.bottom),
      right: Math.floor(rect.right)
    };
  }


  normalizeRect(rect) {
    if (rect.width === undefined) {
      rect.width = rect.right - rect.left;
    }

    if (rect.height === undefined) {
      rect.height = rect.bottom - rect.top;
    }

    return rect;
  }

  render () {
    if (this.props.children instanceof Function) {
      return this.props.children({
        isVisible: this.state.isVisible,
      });
    }

    return null
  }
}

export default Visibility
